import * as Blockly from 'blockly/core';
import { BOARD_CONFIG, BoardType } from '@/(routers)/boards/editor/block/blockConfig';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { BOARD } from '@/(routers)/boards/editor/block/definitions/boards';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { FieldWifi } from '@/(routers)/boards/editor/block/definitions/fields/fieldWifi';

const STATEMENT_ICON = { src: '/images/block/loop.svg', size: 25 };

// WiFi設定はライセンス周りが未実装のため今回は非表示。次スコープ(OTA無線書き込み対応)で再度有効化する。
const WIFI_FEATURE_ENABLED = false;

function appendWifiFields(block: Blockly.Block): void {
    if (block.getField('WIFI')) return;

    const input = block.inputList[0];
    if (!input) return;

    input.removeField('LOOP_LABEL', /* noException */ true);

    input.appendField('が', 'BOARD_SUFFIX');
    input.appendField(new FieldStyledLabel('Wi-Fi', { fontSize: 13 }), 'WIFI_LABEL');
    input.appendField(new FieldWifi(null), 'WIFI');
    input.appendField('でずっと動く ', 'LOOP_LABEL');
}

function removeWifiFields(block: Blockly.Block): void {
    if (!block.getField('WIFI')) return;

    const input = block.inputList[0];
    if (!input) return;

    input.removeField('LOOP_LABEL', true);
    input.removeField('WIFI', true);
    input.removeField('WIFI_LABEL', true);
    input.removeField('BOARD_SUFFIX', true);
    input.appendField('でずっと動く ', 'LOOP_LABEL');
}

defineBlock({
    type: 'schoomy_board',
    colour: BOARD.orange.color,
    useBoardColour: true,
    tooltip: 'ずっと繰り返し実行されます',
    movable: true,
    deletable: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: BOARD.orange.icon, name: 'BOARD_ICON' },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('スクーミーボード', { fontSize: 15, fontWeight: 'bold' }),
                },
                { type: 'change_board_dropdown', name: 'BOARD' },
                { type: 'label', text: 'でずっと動く ', name: 'LOOP_LABEL' },
            ],
        },
        { kind: 'statement', name: 'LOOP', fields: [{ type: 'image', icon: STATEMENT_ICON }] },
    ],

    onInit(this: Blockly.Block) {
        const board = this.getFieldValue('BOARD') as BoardType;
        if (WIFI_FEATURE_ENABLED && board === 'blue') {
            appendWifiFields(this);
        }
    },

    onBoardChange(block: Blockly.Block, board: BoardType) {
        if (WIFI_FEATURE_ENABLED && board === 'blue') {
            appendWifiFields(block);
        } else {
            removeWifiFields(block);
        }
        (block as Blockly.BlockSvg).render();
    },
});

export function updateBoardBlockColors(workspace: Blockly.WorkspaceSvg, board: BoardType): void {
    for (const block of workspace.getAllBlocks(false)) {
        if (block.type === 'schoomy_board') {
            block.setColour(BOARD[board].color);
            block.setFieldValue(BOARD[board].icon.src, 'BOARD_ICON');
        }
        if (block.type === 'setup') {
            block.setColour(BOARD[board].color);
            block.setFieldValue(BOARD[board].setupIcon.src, 'SETUP_ICON');
        }
    }
    workspace.render();
}

export function updateSetupBaud(workspace: Blockly.WorkspaceSvg, board: BoardType): void {
    const { baud } = BOARD_CONFIG[board];
    for (const block of workspace.getAllBlocks(false)) {
        if (block.type === 'setup') block.setFieldValue(String(baud), 'BAUD');
    }
}
